import { Injectable } from '@angular/core';
import { UrlService } from '../../contants/url-service.constant';
import { HttpCustom } from '../http/http-custom.service';
import { PerfilConstant } from '../../contants/perfil.constant';
// tslint:disable-next-line:import-blacklist
import { CiudadAsesor } from '../../models/agente/ciudad-asesor.class';
import { Auxiliar } from '../../models/agente/auxiliar.class';
import { Delegado } from '../../models/agente/delegado.class';
import { InformacionBasicaAgente } from '../../models/agente/informacio-basica-agente.class';
import { Pais } from '../../contants/pais.constant';
import { Delegacion } from '../../models/agente/delegacion.class';
import { CookieService } from 'ngx-cookie';
import { FiltroAgente } from '../../models/filtro/filtro-agente';
import { GrupoPersona } from '../../contants/grupo-persona.constant';
import { Agente } from '../../models/agente/agente.class';
import { Asesor } from '../../models/agente/asesor.class';
import { HeaderPeticion } from '../../models/http/headerPeticion.class';
import { Configuracion } from '../../contants/configuracion.constant';


@Injectable()
export class AgenteService {

  private perfil: String;
  private agente: Agente = null;
  private informacionBasicaAgente: InformacionBasicaAgente = null;



  constructor(private httpCustom: HttpCustom,
    private cookieService: CookieService) {
    this.perfil = null;
  }



  cargarPerfil() {
    // tslint:disable-next-line:no-shadowed-variable
    return new Promise((resolve, reject) => {
      this.httpCustom.getServiceWithHeaders(UrlService.PERFIL, {}, [new HeaderPeticion(Configuracion.HEADER_DESCRIPCION_PETICION, 'Cargando Información del Perfil')]).subscribe(
        result => { this.perfil = result.name; resolve(resolve); },
        error => reject(null)
      );
    });

  }


  logoutAgente() {
    // tslint:disable-next-line:no-shadowed-variable
    return new Promise<String>((resolve, reject) => {
      this.httpCustom.getServiceWithHeaders(UrlService.LOGOUT, {}, [new HeaderPeticion(Configuracion.HEADER_DESCRIPCION_PETICION, 'Saliendo del Cotizador')]).subscribe(
        // tslint:disable-next-line:arrow-return-shorthand
        result => { return resolve(result); },
        // tslint:disable-next-line:arrow-return-shorthand
        error => { return reject(null); }
      );
    });

  }


  async cargarInformacionAgente(): Promise<Agente> {
    let agente: any = null;
    this.informacionBasicaAgente = await this.cargarInformacionBasicaAgente();
    if (this.informacionBasicaAgente !== null) {
      switch (this.perfil) {
        case PerfilConstant.PERFIL_ASESOR: {
          agente = await this.cargarAsesor(this.informacionBasicaAgente);
          break;
        }

        case PerfilConstant.PERFIL_AUXILIAR: {
          agente = this.cargarAuxiliar(this.informacionBasicaAgente);
          this.agregarKAgente(this.informacionBasicaAgente.usuario.toString());
          break;
        }

        case PerfilConstant.PERFIL_DELEGADO:
        case PerfilConstant.PERFIL_COMERCIAL:
        case PerfilConstant.PERFIL_COMERCIAL_DELEGADO:
        case PerfilConstant.PERFIL_SALUD_PROVEDOR_DELEGADO: {
          agente = await this.cargarDelegado(this.informacionBasicaAgente);
          break;
        }

      }
    }

    return agente;
  }


  async cargarAsesor(informacionBasicaAgente: InformacionBasicaAgente): Promise<any> {
    const asesor: Asesor = new Asesor();
    asesor.ciudades = await this.cargarCiudadesAsesor(this.informacionBasicaAgente.dni, this.getCiaMatriz());
    asesor.informacionBasica = informacionBasicaAgente;
    return asesor;
  }



  async cargarAuxiliar(informacionBasicaAgente: InformacionBasicaAgente): Promise<any> {
    const auxiliar: Auxiliar = new Auxiliar();
    auxiliar.informacionBasica = informacionBasicaAgente;
    return auxiliar;
  }

  async cargarDelegado(informacionBasicaAgente: InformacionBasicaAgente): Promise<any> {
    const delegado: Delegado = new Delegado();
    delegado.delegaciones = await this.cargarDelegaciones(this.informacionBasicaAgente.dni, this.getCodigoDelegacion());
    delegado.informacionBasica = informacionBasicaAgente;
    return delegado;
  }


  cargarInformacionBasicaAgente(): Promise<InformacionBasicaAgente> {
    // tslint:disable-next-line:no-shadowed-variable
    return new Promise((resolve, reject) => {
      this.httpCustom.getServiceWithHeaders(UrlService.INFORMACION_BASICA_AGENTE, {}, [new HeaderPeticion(Configuracion.HEADER_DESCRIPCION_PETICION, 'Cargando Información Básica del Asesor')]).subscribe(
        result => {
          let informacion: InformacionBasicaAgente = new InformacionBasicaAgente();
          informacion.dni = result.dni;
          informacion.nombreCompleto = result.fullName;
          informacion.usuario = result.userName;

          resolve(informacion)
        },
        error => reject(null)
      );
    });
  }


  cargarInformacionComplementariaAgente(codigo: String) {
    // tslint:disable-next-line:no-shadowed-variable
    return new Promise((resolve, reject) => {
      this.httpCustom.getServiceWithHeaders(UrlService.INFORMACION_COMPLEMENTARIA_AGENTE + codigo, { ciaMatriz: this.getCiaMatriz() }, [new HeaderPeticion(Configuracion.HEADER_DESCRIPCION_PETICION, 'Cargando Información Complementaria del Asesor')]).subscribe(
        result => {
          this.agente.informacionComplementaria = result;
          this.agregarKAgente(codigo.toString());
          return resolve(true);
        },
        error => {
          this.agregarKAgente('');
          this.agente.informacionComplementaria = null;
          return resolve(false);
        }
      );
    });


  }

  asesorIsProteccion(): Promise<any> {
    // tslint:disable-next-line:no-shadowed-variable
    return new Promise((resolve, reject) => {
      let cargo = this.agente !== null ?
      this.agente.informacionComplementaria !== null ?
      this.agente.informacionComplementaria !== null ?
      this.agente.informacionComplementaria.asesor.cargo : '': '': '';

      this.httpCustom.getServiceWithHeaders(UrlService.URL_HOME_PROTECCION, {cargoAgente: cargo}, [new HeaderPeticion(Configuracion.HEADER_DESCRIPCION_PETICION, 'Cargando')]).subscribe(
        result => { resolve(result.isProteccion); },
        error => reject(error)
      );
    });

  }

  agregarKAgente(valor: string) {
    this.removeKAgente();
    this.cookieService.put('KAgente', btoa(valor), { domain: '.sura.com' });
  }

  removeKAgente() {
    this.cookieService.remove('KAgente');
  }

  obtenerCodigoAsesor(): String {
    let codAsesorCookie = this.cookieService.get('KAgente');
    if(codAsesorCookie){
      return atob(this.cookieService.get('KAgente'));
    }
    return null;
  }

  cargarCiudadesAsesor(dni: String, ciaMatriz: String): Promise<CiudadAsesor[]> {
    // tslint:disable-next-line:no-shadowed-variable
    return new Promise((resolve, reject) => {
      this.httpCustom.getServiceWithHeaders(UrlService.CIUDADES_ASESOR, { dniAsesor: dni, ciaMatriz: ciaMatriz }, [new HeaderPeticion(Configuracion.HEADER_DESCRIPCION_PETICION, 'Cargando Ciudades del Asesor')]).subscribe(
        result => {
          return resolve(result);
        },
        error => {
          return reject(null);
        }
      );
    });

  }

  cargarDelegaciones(dniUsuario: String, administradora: String): Promise<Delegacion[]> {
    // tslint:disable-next-line:no-shadowed-variable
    return new Promise((resolve, reject) => {
      this.httpCustom.getServiceWithHeaders(UrlService.DELEGACIONES_USUARIO + '/' + dniUsuario + '/' + administradora, {}, [new HeaderPeticion(Configuracion.HEADER_DESCRIPCION_PETICION, 'Cargando Delegaciones del Delegado')]).subscribe(
        result => {
          return resolve(result);
        },
        error => {
          return reject(null);
        }
      );
    });

  }


  getCodigoPais() {
    let codigoPais = Pais.CODIGO_COLOMBIA;
    if (this.validarPanama()) {
      codigoPais = Pais.CODIGO_PANAMA;
    }

    return codigoPais;
  }

  getgrupoPersona() {
    let grupoPersona = GrupoPersona.DOCUMENTO_VALIDO_COLOMBIA;
    if (this.validarPanama()) {
      grupoPersona = GrupoPersona.DOCUMENTOS_INTERNACIONALES;
    }
    return grupoPersona;
  }


  getCiaMatriz() {
    let ciaMatriz = Pais.CIA_MATRIZ_COLOMBIA;
    if (this.validarPanama()) {
      ciaMatriz = Pais.CIA_MATRIZ_PANAMA;
    }
    return ciaMatriz;
  }

  getCodigoDelegacion() {
    let codigoDelegacion = Pais.CODIGO_DELEGACION_COLOMBIA;
    if (this.validarPanama()) {
      codigoDelegacion = Pais.CODIGO_DELEGACION_PANAMA;
    }
    return codigoDelegacion;
  }


  validarPanama() {
    return (this.cookieService.get('CodCountry') !== undefined &&
      this.cookieService.get('CodCountry') !== null
      && atob(this.cookieService.get('CodCountry')) === 'P');
  }
  getAgente() {
    return this.agente;
  }

  setAgente(agente) {
    this.agente = agente;
  }


  getPerfil() {
    return this.perfil;
  }

  setPerfil(perfil) {
    this.perfil = perfil;
  }


  isPerfilAsesorOADelegado(): boolean {
    return (this.perfil === PerfilConstant.PERFIL_ASESOR || this.perfil === PerfilConstant.PERFIL_DELEGADO ||
      this.perfil === PerfilConstant.PERFIL_COMERCIAL || this.perfil === PerfilConstant.PERFIL_COMERCIAL_DELEGADO ||
      this.perfil === PerfilConstant.PERFIL_SALUD_PROVEDOR_DELEGADO);
  }


  getFiltroAgente(): FiltroAgente {
    return this.agente !== null && this.agente !== undefined ? this.agente.getFiltroAgente() : null;
  }


  getDniAgente() {
    return this.agente !== null && this.agente !== undefined ? this.agente.getDniAgente() : null;
  }


  getCodigoAgente() {
    return this.agente !== null && this.agente !== undefined ? this.agente.getCodigoAgente() : null;
  }

  getUsuarioAgente() {
    return this.agente.informacionBasica.usuario;
  }

  habilitarOpcionesAgente() {
    return this.agente !== null && this.agente !== undefined ? this.agente.habilitarOpcionesAgente() : null;
  }
}



// WEBPACK FOOTER //
// ./src/app/services/agente/agente.service.ts